import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL } from '../Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import Swal from 'sweetalert2';
import modulesConfig from '../common/modulesConfig';

const ChangePermissions = () => {
  const { roleId } = useParams();
  const [checkedPermissions, setCheckedPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  // Load permissions on component mount
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const res = await fetch(`${API_URL}/get-permissions/${roleId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
          }
        });
        const data = await res.json();
        if (data.success) {
          const permissionMap = {};
          data.permissions.forEach(p => {
            permissionMap[p] = true;
          });
          setCheckedPermissions(permissionMap);
        } else {
          Swal.fire("Error", data.message || "Failed to load permissions", "error");
        }
      } catch (err) {
        Swal.fire("Error", "Failed to fetch permissions", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [roleId]);

  const handleCheckboxChange = (permId, checked) => {
    setCheckedPermissions(prev => ({
      ...prev,
      [permId]: checked
    }));
  };

  const handleUpdate = async () => {
    const selectedPermissions = Object.keys(checkedPermissions).filter(key => checkedPermissions[key]);

    try {
      const response = await fetch(`${API_URL}/update-permissions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        },
        body: JSON.stringify({
          roleId,
          permissions: selectedPermissions
        })
      });
      const result = await response.json();
      if (result.success) {
        Swal.fire("Success", "Permissions updated!", "success");
      } else {
        Swal.fire("Error", result.message || "Failed to update permissions", "error");
      }
    } catch (err) {
      Swal.fire("Error", "API error.", "error");
    }
  };

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt;
              <a href="/Dashboard">Master</a> &gt;
              <span className="last-crumb">Change Permission</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="show-order-area dashboard">
                <div className='role-permission-area'>
                  <h3>Role Permissions :</h3>

                  {loading ? (
                    <p>Loading permissions...</p>
                  ) : (
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>Module Name</th>
                          <th>Permissions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modulesConfig.map((module) => (
                          <tr key={module.name}>
                            <td>{module.name}</td>
                            <td>
                              <ul className="list-unstyled">
                                {module.permissions.map((perm) => (
                                  <li key={perm.id}>
                                    <div className="form-check">
                                      <label className="checkbox">
                                        <input
                                          type="checkbox"
                                          id={perm.id}
                                          checked={!!checkedPermissions[perm.id]}
                                          onChange={e => handleCheckboxChange(perm.id, e.target.checked)}
                                        />
                                        <span className="default"></span>
                                      </label>
                                      <label className="form-check-label" htmlFor={perm.id}>
                                        {perm.label}
                                      </label>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  <hr />
                  <button className='btn btn-danger btn-sm' onClick={handleUpdate}>Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ChangePermissions;
